import * as log from "loglevel";

class LogService {
    static getLogger = () => {
        return log;
    };

    static setLevel = (level) => {
        if (log.levels[String(level).toUpperCase()] === undefined) {
            log.error("LogService setLevel() called with invalid level: " + level);
            return;
        }

        log.setLevel(level);
    };

    static enableLog = (level = log.levels.TRACE) => {
        level = String(level).toLowerCase();

        log.debug("LogService log enabled and set to " + level);
        log.setLevel(level);
    };

    static disableLog = () => {
        log.debug("LogService log disabled and set to " + log.levels.SILENT);
        log.setLevel(log.levels.SILENT);
    };
}

const url = window.location.href;
const isDev = url.indexOf("useMocks=true") !== -1 || url.indexOf("debug=true") !== -1;
isDev ? log.setLevel(log.levels.DEBUG) : log.setLevel(log.levels.ERROR);

export default LogService;
